<template>
  <div class="categoryProductslist">
    <div>
      <div class="title" v-if="FilterCriteria.length > 0">
        <div class="title-query" v-if="hideshow">
          <div
            class="title-query-body"
            v-for="(fItem, fIndex) in FilterCriteria"
            :key="fIndex"
          >
            <div class="title-query-body-left">{{ fItem.field_key }}</div>
            <div
              class="title-query-body-cnt"
              v-if="selectshow != fItem.field_key"
            >
              <el-button
                type="text"
                v-for="item in fItem.show_map"
                :key="item"
                :class="fItem.value.includes(item) ? '' : 'btnclass'"
                @click="chooseItem(item, fIndex)"
                >{{ item }}
              </el-button>
            </div>
            <div class="title-query-body-cnt" v-else>
              <div>
                <el-checkbox-group v-model="fItem.value">
                  <el-checkbox
                    v-for="item in fItem.field_map"
                    :key="item"
                    :label="item"
                  ></el-checkbox>
                </el-checkbox-group>
              </div>
              <div style="text-align: center; margin-top: 20px">
                <el-button @click="selectqx(fItem.field_key, fIndex)"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  @click="selectqd(fItem.field_key, fIndex)"
                  >确定</el-button
                >
              </div>
            </div>
            <div class="title-query-body-right">
              <el-button
                v-if="fItem.field_map.length > 12"
                @click="morelist(fItem.field_key)"
                >{{ duoshow == fItem.field_key ? "收起" : "更多" }}</el-button
              >
              <el-button @click="selectlist(fItem.field_key, fIndex, fItem)"
                >多选</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="title-query-btn">
        <div class="title-query-btn-left d-flex a-center">
          <el-button
            v-for="item in taglist"
            :key="item.id"
            :type="fromcopy.audit_type == item.id ? 'primary' : ''"
            @click="tagquery(item)"
            >{{ item.name }}({{ tagnum[item.num] }})</el-button
          >
          <div style="width: 150px" class="d-flex a-center goodsName">
            <span>商品名称：</span>
            <el-input
              v-model="fromcopy.title"
              placeholder="请输入"
              clearable
            ></el-input>
          </div>
          <div
            class="d-flex a-center goodsName"
            v-if="fromcopy.audit_type == 2"
          >
            <span style="width: 100px">审核状态:</span>
            <el-select
              v-model="audit_type_1"
              filterable
              placeholder="请选审核状态"
            >
              <el-option
                v-for="item in list104"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="d-flex a-center goodsName"
            v-if="fromcopy.audit_type == 3"
          >
            <span style="width: 100px">审核状态:</span>
            <el-select
              v-model="audit_type_1"
              filterable
              placeholder="请选审核状态"
            >
              <el-option
                v-for="item in list106"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="d-flex a-center goodsName"
            v-if="fromcopy.audit_type == 4"
          >
            <span style="width: 100px">审核状态:</span>
            <el-select
              v-model="audit_type_1"
              filterable
              placeholder="请选审核状态"
            >
              <el-option
                v-for="item in list105"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>

          <!-- 只有待审核显示提审时间 start -->
          <!-- <div
            style="width: 280px"
            class="d-flex a-center goodsName"
            v-if="fromcopy.audit_type == 104"
          >
            <span>提审时间：</span>
            <el-date-picker
              v-model="audit_at"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div> -->
          <!-- 只有待审核显示提审时间 end -->
        </div>
        <div class="title-query-btn-right">
          <el-button @click="drawerclcik">表头排序</el-button>
          <el-button type="primary" @click="querylist">刷新</el-button>
          <span style="color: red" class="mr10">坑位：{{ slot }}个</span>
          <el-button
            v-if="FilterCriteria.length > 0"
            icon="el-icon-s-fold"
            plain
            @click="hideshow = !hideshow"
            >{{ hideshow ? "隐藏" : "展开" }}</el-button
          >
          <el-button :disabled="disabledExport" @click="onHandleExport"
            >导出</el-button
          >

          <el-button type="primary" @click="querylist">查询</el-button>
          <el-button icon="el-icon-refresh-right" @click="Reset"
            >重置</el-button
          >
        </div>
      </div>
      <div class="title-query-item">
        <el-tag
          closable
          v-for="(item, index) in tag_list"
          :key="index"
          @close="close(item, index)"
          >{{ item.name }}</el-tag
        >
      </div>
    </div>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="table"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <div>
          <div v-for="(item, index) in sort_list" :key="index">
            <el-table-column
              prop="kv"
              v-if="item.value == 'kv'"
              align="center"
              :label="item.label"
              :min-width="item['min-width']"
            >
              <template slot-scope="scope">
                <div @click="onHandelDetails(scope.row)" class="imgs">
                  <img class="img-box" :src="scope.row.kv" alt="" />
                  <span v-if="scope.row.kv_last_time">{{
                    timename(scope.row.kv_last_time)
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              v-else-if="item.value == 'title'"
              align="center"
              :label="item.label"
              :min-width="item['min-width']"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="onHandelDetails(scope.row)">{{
                  scope.row.title
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              :prop="item.value"
              v-else
              align="center"
              :label="item.label"
              :min-width="item['min-width']"
            >
            </el-table-column>
          </div>

          <div>
            <el-table-column
              label="操作"
              align="center"
              min-width="150"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  v-if="scope.row.operate_btn == 1"
                  @click="down(scope.row)"
                  size="mini"
                  >下架</el-button
                >
                <el-button
                  v-if="scope.row.operate_btn == 2"
                  type="primary"
                  @click="adopt(scope.row)"
                  size="mini"
                  >通过</el-button
                >
                <el-button
                  v-if="scope.row.operate_btn == 2"
                  type="danger"
                  @click="reject(scope.row)"
                  size="mini"
                  >驳回</el-button
                >
                <el-button
                  v-if="scope.row.audit_type == 5"
                  type="danger"
                  @click="takedown(scope.row)"
                  size="mini"
                  >下架原因</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="audit_status_txt"
              align="center"
              label="审核状态"
              fixed="right"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text">{{
                    scope.row.audit_status_txt
                  }}</el-button>
                  <div v-if="scope.row.buyer">
                    {{ scope.row.buyer.fullname }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              label="开市价"
              fixed="right"
            >
              <template slot="header" slot-scope="scope">
                <div class="title-item">
                  <div>开市价</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="weight_price"
              align="center"
              label="净单价"
              min-width="100"
              fixed="right"
            >
            </el-table-column>
            <el-table-column
              prop="percent_rate"
              fixed="right"
              align="center"
              label="售后率"
            >
            </el-table-column>
            <el-table-column
              prop="repurchase_30"
              fixed="right"
              align="center"
              label="复购率"
            >
            </el-table-column>
          </div>
        </div>
      </el-table>
    </div>
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="是否驳回"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="500px"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="驳回原因" prop="reason">
            <div style="width: 302px">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="ruleForm.reason"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="图片上传">
            <b-file-upload
              key="reject_img"
              :accepts="['jpg', 'jpeg', 'png']"
              :limit="4"
              v-model="detailPicList"
            ></b-file-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ruleFormqr">确认</el-button>
      </span>
    </el-dialog>
    <GoodsDetails ref="GoodsDetailsref"></GoodsDetails>
    <dialogtable ref="dialogtableref"></dialogtable>
    <belowdialog
      ref="belowdialogref"
      @successbelow="successbelow"
    ></belowdialog>

    <el-drawer
      title="品类排序"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div>
        <div style="text-align: right; margin-bottom: 20px">
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
        <el-table
          ref="draggableTable"
          :data="tableDatasorst"
          row-key="label"
          stripe
          @row-dragged="handleRowDragged"
          height="100%"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        >
          <el-table-column type="index" width="100" align="center" label="序号">
          </el-table-column>

          <el-table-column prop="label" label="名称" align="center"></el-table-column>
          <el-table-column
            prop="item.prop"
            align="center"
            label="操作"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <i class="el-icon-rank"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import GoodsDetails from "@/components/GlobalDetails.vue";
import dialogtable from "./modules/dialog-table.vue";
import BFileUpload from "@/components/business/BFileUpload/index.vue";
import belowdialog from "../modules/below-dialog/index.vue";
import { cidlistexport } from "@/api/export/center.js";
import Sortable from "sortablejs";
export default {
  name: "Selected-products",
  components: { GoodsDetails, dialogtable, BFileUpload, belowdialog },
  data() {
    return {
      drawer: false,
      tableDatasorst: [],
      //展开收起
      hideshow: true,
      tag_list: [],
      tagnum: {},
      sort_list: [],
      taglist: [
        {
          name: "全部",
          id: "1",
          num: "all",
        },
        {
          name: "待审核",
          id: "2",
          num: "no_audit",
        },
        {
          name: "已驳回",
          id: "3",
          num: "reject",
        },
        {
          name: "已通过",
          id: "4",
          num: "audited",
        },
        {
          name: "已下架",
          id: "5",
          num: "discontinued",
        },
      ],
      tableData: [],
      loading: false,
      currentPage: 0,
      total: 0,
      FilterCriteria: [],
      list104: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "待招商审核",
          id: "1",
        },
        {
          name: "待买手审核",
          id: "2",
        },
        {
          name: "待运营审核",
          id: "3",
        },
      ],
      list105: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "招商审核（通过）",
          id: "1",
        },
        {
          name: "买手审核（通过）",
          id: "2",
        },
        {
          name: "运营审核（通过）",
          id: "3",
        },
      ],
      list106: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "招商驳回",
          id: "1",
        },
        {
          name: "买手驳回",
          id: "2",
        },
        {
          name: "运营驳回",
          id: "3",
        },
      ],
      fromcopy: {
        logistic_business_id: "",
        cid: "",
        category_tag_id: "", // 三级id
        audit_type_1: "", // 三级id
        audit_type: "1", //	number	审批状态 104待审核  105通过 106驳回  3已下架 传空或空字符串为全部
        // sort_key: "", //	T文本	是	排序列
        // sort: "", //	T文本	是	排序方式
        page: 1,
        pageSize: 50,
        search_attribute_list: [], //自定义属性搜索
        title: "",
        audit_start: "",
        audit_end: "",
      },
      audit_type_1: "",
      from: {},
      fromFilter: {
        logistic_business_id: "", //	T文本	是	集配中心
        cid: "", //	T文本	是	二级分类ID
        category_tag_id: "", // 三级id
        audit_type_1: "", // 三级id
      },
      // brand_name: [],
      // package_type: [],
      // origin_name: [],
      // grade: [],
      // checkList_brand_name: [],
      // checkList_package_type: [],
      // checkList_origin_name: [],
      // checkList_grade: [],
      duoshow: "",
      selectshow: "",
      // select_name: [
      //   {
      //     name: "品牌",
      //     key: "brand_name",
      //   },
      //   {
      //     name: "包装",
      //     key: "package_type",
      //   },
      //   {
      //     name: "产地",
      //     key: "origin_name",
      //   },
      //   {
      //     name: "等级",
      //     key: "grade",
      //   },
      // ],
      ruleForm: {
        product_id: "", // 商品id
        status: 2, // 状态 1 通过 2 驳回
        reason: "", // 驳回原因
        reject_img: "", // 驳回图片数组
      },
      rules: {
        reason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
        // reject_img: [
        //   { required: true, message: "请上传图片", trigger: "change" },
        // ],
      },
      centerDialogVisible: false,
      detailPicList: [], // 图片列表
      selectInfo: {},
      audit_at: [],
      slot: "",
      disabledExport: false,
    };
  },
  watch: {
    /**
     * 图片发生改变
     */
    detailPicList() {
      const res = this.detailPicList?.map((item) => item.url).join(",");
      this.ruleForm.reject_img = res;
      console.log(this.ruleForm, "11111111111");
    },
  },
  created() {
    this.fromFilter.cid = this.$route.query.cid;
    this.fromFilter.logistic_business_id =
      this.$route.query.logistic_business_id;
    this.fromFilter.category_tag_id = this.$route.query.tagId;
    this.fromcopy.cid = this.$route.query.cid;
    this.fromcopy.logistic_business_id = this.$route.query.logistic_business_id;
    this.fromcopy.category_tag_id = this.$route.query.tagId;
    this.from = JSON.parse(JSON.stringify(this.fromcopy));
  },
  mounted() {
    this.hqfilterlist();
  },
  methods: {
    initSortable() {
      console.log(this.$refs.draggableTable);
      const el = this.$refs.draggableTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );
      this.sortable = Sortable.create(el, {
        onEnd: (evt) => {
          const { newIndex, oldIndex } = evt;
          const movedItem = this.tableDatasorst.splice(oldIndex, 1)[0];
          this.tableDatasorst.splice(newIndex, 0, movedItem);
        },
      });
    },
    handleRowDragged(newData) {
      this.tableDatasorst = newData; // 如果需要更新视图或其他操作可以在这里处理
    },
    drawerclcik() {
      this.drawer = true;

      this.$nextTick(() => {
        this.initSortable();
      });
    },
    submit() {
   
      
      this.$api.examine
        .sortsave({
          sort_arr: this.tableDatasorst,
          category_tag_id: this.$route.query.tagId,
         
        })
        .then((res) => {
          console.log(res, "获取数据");
          this.hqlist();
          this.drawer = false;
        });
    },
    handleClose(done) {
      this.drawer = false;
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    /**
     * 导出
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.fromcopy,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await cidlistexport(query);
        this.goExportCenter();
      } catch (err) {
        this.disabledExport = false;
        console.log("ajax cidlistexport err", err);
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    //下架
    successbelow() {
      this.getproducttotal();
      this.hqlist();
    },
    // 提审时间改变
    timeChange() {
      if (this.audit_at && this.audit_at.length > 1) {
        this.fromcopy.audit_start = this.audit_at[0];
        this.fromcopy.audit_end = this.audit_at[1];
        this.from.audit_start = this.audit_at[0];
        this.from.audit_end = this.audit_at[1];
      } else {
        this.fromcopy.audit_start = "";
        this.fromcopy.audit_end = "";
        this.from.audit_start = "";
        this.from.audit_end = "";
      }
    },
    // 选择单个 单选
    chooseItem(e, index) {
      console.log(e, index, "1212");
      this.FilterCriteria[index].value = [e];
      this.FilterCriteria[index].type = "radio"; // 单选
      this.$set(this.FilterCriteria, index, this.FilterCriteria[index]);
      console.log(this.FilterCriteria, " this.FilterCriteria===");
    },
    adopt(el) {
      this.$confirm(
        `${el.title}[等级${el.grade}]  [${el.sku_code}]`,
        "是否确定审核通过？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.examine
          .producthandle({
            product_id: el.id, // 商品id
            status: 1, // 状态 1 通过 2 驳回
            reason: "", // 驳回原因
            reject_img: "", // 驳回图片数组
          })
          .then((res) => {
            this.getproducttotal();
            this.hqlist();
          })
          .catch(() => {});
      });
    },
    down(row) {
      this.$refs.belowdialogref.onInitData(row, 2);
    },
    takedown(e) {
      this.$confirm(e.product_offline_reason, "下架原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {});
    },
    reject(item) {
      this.ruleForm.product_id = item.id;
      this.ruleForm.reason = "";
      this.ruleForm.reject_img = "";
      this.detailPicList = [];
      this.centerDialogVisible = true;
    },
    ruleFormqr() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.$api.examine.producthandle(this.ruleForm).then((res) => {
            this.getproducttotal();
            this.hqlist();
            this.centerDialogVisible = false;
          });
        }
      });
    },
    countclcik(e) {
      if (e.fleet_sku_quality_count == 0) {
        return;
      }
      this.$refs.dialogtableref.oninit(e);
    },
    // 多选 取消
    selectqx(e, index) {
      //  console.log(e, "e==");
      this.selectshow = "";
      this.FilterCriteria[index].value = this.selectInfo.value;
    },
    // 多选 确定
    selectqd(e, index) {
      this.selectshow = "";
      this.FilterCriteria[index].type = "checkbox"; // 多选
    },
    /**
     * 展示详情
     */
    onHandelDetails(row) {
      // this.detailsVisible = true;
      // this.detailsLoading = true;
      this.goodsDetail = row;
      this.$refs.GoodsDetailsref.hqlist(this.goodsDetail);
      // 模拟loading
      // setTimeout(() => {
      //   this.detailsLoading = false;
      // }, 500);
    },
    timename(time) {
      // 把开始时间   转为  时间戳
      let times = time + "000"; //后端返回时间戳是秒，没办法比对只能手动拼接三个零
      let result;
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let month = day * 30;
      let now = new Date().getTime();
      let diffValue = now - times;

      if (diffValue < 0) {
        return;
      }
      let monthC = diffValue / month;
      let weekC = diffValue / (7 * day);
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      if (monthC >= 1) {
        if (monthC <= 12) result = "" + parseInt(monthC) + "月前";
        else {
          result = "" + parseInt(monthC / 12) + "年前";
        }
      } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else {
        result = "刚刚";
      }
      return result;
    },
    // 展示更多
    morelist(e) {
      if (this.duoshow == e) {
        this.duoshow = "";
      } else {
        this.duoshow = e;
      }

      this.filtersl();
    },
    // 多选
    selectlist(e, index, selectInfo) {
      console.log(e, selectInfo, "122selectInfo");

      if (this.selectshow == e) {
        this.selectshow = "";
        this.FilterCriteria[index].value = this.selectInfo.value;
      } else {
        this.selectInfo = JSON.parse(JSON.stringify(selectInfo)); // 当前所选中的值
        this.selectshow = e;
        this.FilterCriteria[index].value =
          selectInfo.type == "checkbox" ? selectInfo.value : [];
      }

      this.filtersl();
    },
    getproducttotal() {
      this.$api.product.producttotal(this.from).then((res) => {
        console.log(res);
        this.tagnum = res.data;
      });
    },
    //状态筛选
    tagquery(item) {
      this.from.audit_type = item.id;
      this.fromcopy.audit_type = item.id;
      // 清空提审时间
      this.from.audit_start = "";
      this.fromcopy.audit_start = "";
      this.from.audit_end = "";
      this.fromcopy.audit_end = "";
      this.from.audit_type_1 = "";
      this.fromcopy.audit_type_1 = "";
      this.audit_type_1 = "";
      this.audit_at = [];
      this.hqlist();
      this.getproducttotal();
    },
    sortChange(e) {
      if (e == 1) {
        this.from.sort_key = "price";
      } else if (e == 2) {
        this.from.sort_key = "weight";
      } else {
        this.from.sort_key = "gross_weight";
      }
      this.from.sort = this.from.sort == "asc" ? "desc" : "asc";
      this.hqlist();
    },
    close(e, index) {
      this.tag_list.splice(index, 1);
      // 删除对应的筛选项 所选值
      this.FilterCriteria[e.eIndex].value = [];
      console.log(this.FilterCriteria, " this.FilterCriteria==");

      let getSelectList = [];
      this.FilterCriteria.map((gItem) => {
        if (gItem.value.length > 0) {
          getSelectList.push({
            field_key: gItem.field_key,
            field_map: gItem.value,
          });
        } else {
          getSelectList.push({
            field_key: gItem.field_key,
            field_map: [],
          });
        }
      });
      this.from.search_attribute_list = getSelectList;
      this.fromcopy.search_attribute_list = getSelectList;

      this.currentPage = 1;
      this.from.page = 1;
      this.hqlist();
      this.getproducttotal();
    },
    Reset() {
      Object.assign(this.$data.from, this.$options.data().from);
      Object.assign(this.$data.fromcopy, this.$options.data().fromcopy);
      this.tag_list = [];
      this.audit_at = [];
      // 重置上面筛选 自定义属性
      this.FilterCriteria.map((item, index) => {
        item.value = [];
        item.type = "radio";
      });

      this.fromcopy.cid = this.$route.query.cid;
      this.fromcopy.logistic_business_id =
        this.$route.query.logistic_business_id;
      this.fromcopy.category_tag_id = this.$route.query.tagId;

      // this.querylist();
      // this.getproducttotal();
    },
    //匹配展示筛选条件
    taglistname() {
      this.tag_list = [];
      console.log(this.FilterCriteria, "h显示tag");
      let name = "";
      this.FilterCriteria.forEach((el, eIndex) => {
        name = el.field_key + "：";
        if (el.value.length > 0) {
          el.value.forEach((els) => {
            name = name + els + ",";
          });
          this.tag_list.push({
            name: name,
            eIndex: eIndex,
            key: el.field_key,
          });
        }
      });
    },
    querylist() {
      this.taglistname();
      console.log(this.fromcopy, "122");
      let getSelectList = [];
      this.FilterCriteria.map((gItem) => {
        if (gItem.value.length > 0) {
          getSelectList.push({
            field_key: gItem.field_key,
            field_map: gItem.value,
          });
        } else {
          getSelectList.push({
            field_key: gItem.field_key,
            field_map: [],
          });
        }
      });
      this.fromcopy.audit_type_1 = this.audit_type_1;
      this.fromcopy.search_attribute_list = getSelectList;
      this.from = JSON.parse(JSON.stringify(this.fromcopy));
      this.currentPage = 1;
      this.from.page = 1;
      this.hqlist();
      this.getproducttotal();
    },
    filtersl() {
      let obj = JSON.parse(JSON.stringify(this.FilterCriteria));

      this.FilterCriteria.forEach((sItem, sIndex) => {
        console.log(sItem, "212");
        if (this.duoshow == sItem.field_key) {
          sItem.show_map = obj[sIndex].field_map;
        } else {
          sItem.show_map =
            obj[sIndex].field_map.length > 12
              ? obj[sIndex].field_map.splice(0, 12)
              : obj[sIndex].field_map;
        }
      });
    },
    hqfilterlist() {
      this.$api.product.productfilterlist(this.fromFilter).then((res) => {
        console.log(res);
        this.slot = res.data.slot || "0";
        this.FilterCriteria =
          res.data.category_filed.length > 0 ? res.data.category_filed : [];
        if (this.FilterCriteria.length > 0) {
          this.FilterCriteria.forEach((fItem) => {
            if (!Array.isArray(fItem.value)) {
              this.$set(fItem, "value", []); // 用 Vue.set 确保响应式
            }
            fItem.type = "radio"; // 默认单选
          });
        }
        if (res.data.filter_list) {
          this.from = res.data.filter_list;
          this.fromcopy = res.data.filter_list;
          // 回显提审时间
          this.audit_at =
            res.data.filter_list.audit_start && res.data.filter_list.audit_end
              ? [
                  res.data.filter_list.audit_start,
                  res.data.filter_list.audit_end,
                ]
              : [];
          // 回显自定义属性
          let tmpSelectedAattribute = [];
          if (
            res.data.filter_list.search_attribute_list &&
            res.data.filter_list.search_attribute_list.length > 0
          ) {
            this.FilterCriteria.map((item, index) => {
              console.log(item, "item==");

              let tmpOBj = res.data.filter_list.search_attribute_list.find(
                (child) => child.field_key == item.field_key
              );
              // 如果有 则回显 赋值
              if (tmpOBj && tmpOBj.field_map.length > 0) {
                item.value = tmpOBj.field_map || [];
                tmpSelectedAattribute.push({
                  field_key: item.field_key,
                  field_map: tmpOBj.field_map,
                });
              } else {
                item.value = [];
                tmpSelectedAattribute.push({
                  field_key: item.field_key,
                  field_map: [],
                });
              }
            });
          } else {
            this.FilterCriteria.map((item, index) => {
              tmpSelectedAattribute.push({
                field_key: item.field_key,
                field_map: [],
              });
            });
          }

          console.log(tmpSelectedAattribute), "tmpSelectedAattribute==";
          this.fromcopy.search_attribute_list = tmpSelectedAattribute;
          this.from.search_attribute_list = tmpSelectedAattribute;
          this.audit_type_1 = this.fromcopy.audit_type_1;

          this.taglistname();
        } else {
          Object.assign(this.$data.from, this.$options.data().from);
          Object.assign(this.$data.fromcopy, this.$options.data().fromcopy);

          this.fromcopy.cid = this.$route.query.cid;
          this.fromcopy.logistic_business_id =
            this.$route.query.logistic_business_id;
          this.fromcopy.category_tag_id = this.$route.query.tagId;

          this.from.cid = this.$route.query.cid;
          this.from.logistic_business_id =
            this.$route.query.logistic_business_id;
          this.from.category_tag_id = this.$route.query.tagId;
        }
        console.log(this.from, this.fromcopy, this.FilterCriteria, "122");
        this.filtersl();
        this.hqlist();
        this.getproducttotal();
      });
    },
    hqlist() {
      this.loading = true;
      this.$api.product
        .productcidlist(this.from)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.sort_list = res.data.sort_list;
          this.tableDatasorst = JSON.parse(JSON.stringify(res.data.sort_list));
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
          console.log(this.sort_list, "111111");
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>

<style lang="scss">
.categoryProductslist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  // .el-table__header-wrapper{
  //   border-top: 2px solid #000;
  // }

  //   .el-table th.el-table__cell.is-leaf, .el-table td.el-table__cell {
  //     border-bottom: 2px solid #000;
  // }
  .el-table--border .el-table__cell {
    border-width: 4px !important; /* 修改这里的值来改变粗细 *
}


.el-table .el-table__body-wrapper tbody td,
.el-table .el-table__header-wrapper thead th {
    border-width: 4px !important; /* 修改这里的值来改变粗细 */
  }
  .title-query-btn {
    display: flex;

    padding-top: 10px;
    &-left {
      flex: 1;
    }
    &-right {
    }
  }
  .title-query-body {
    display: flex;
    // align-items: center;
    border: 1px solid #ccc;

    .title-query-body-left {
      padding: 15px;
      box-sizing: border-box;
      background-color: #999;
      display: flex;
      align-items: center;
    }
    .title-query-body-cnt {
      padding: 5px;
      box-sizing: border-box;
      flex: 1;
    }
    .title-query-body-right {
      padding: 5px;
      box-sizing: border-box;
    }
  }
  .title-query-item {
    margin: 10px 0;
    .el-tag {
      margin-right: 10px;
    }
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }
  .imgs {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img-box {
    width: 20px;
    height: 20px;
  }
  .title-item {
    display: flex;
    align-items: center;
    justify-content: center;
    .title-item-icon {
      display: flex;
      flex-direction: column;
    }
  }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .btnclass {
    color: #000;
  }
  .goodsName {
    margin-left: 10px;
    .el-input {
      flex: 1;
    }
    .el-date-editor {
      flex: 1;
    }
  }
}
</style>
